window.onload = function() {
    $.each($('[data-modals]'), function(index, value) {
        $(value).magnificPopup({
            type: 'ajax',
            closeBtnInside: true,
          fixedBgPos: true,
          fixedContentPos: true,
        });
    });
  initializeCheckingAddOrderOneClickModal();
  function initializeCheckingAddOrderOneClickModal() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (addedNode) {
            if (addedNode.classList?.contains('orderOneClick') && addedNode.innerHTML.includes('{{successMessage}}')) {
              new window.oneClickOrder({
                el: addedNode.querySelector('[inline-template]')
              });
            }
          });
        }
      });
    });
    observer.observe(document.body, {childList: true, subtree: true});
  }
}